const theme = {
  palette: {
    primary: {
      main: "#144BC8",
      light: "#3E85EF",
      dark: "#0048D0",
    },
    secondary: {
      main: "#00CDEC",
      light: "#3EDEF0",
      dark: "#46C8C8",
    },
    tertiary: {
      main: "#F5CF46",
      light: "#B4E128",
      dark: "#096A75",
      medium: "#951E1E00",
      lighter: "#FFFFFF80",
    },
    neutral: {
      darkest: "#000000",
      darker: "#262C2B",
      dark: "#252E2D",
      medium: "#707070",
      light: "#f8f8f8",
      lighter: "#E2E0E0",
      lightest: "#ffffff",
    },
    success: {
      dark: "#147c38",
      light: "#e7f2eb",
    },
    error: {
      dark: "#df402b",
      light: "#fcecea",
    },
    alert: {
      dark: "#ddac00",
      light: "#fcf7e5",
    },
    information: {
      dark: "#2f80ed",
      light: "#eaf2fd",
    },
  },
};

export default theme;
